import InternalRoutes from "Shared/Constants/InternalRoutes";

const getHighestOrderNonModularRoute = (pathname: string) => {
  const pathnameSubRoutes = pathname.split("/").slice(1);
  for (let i = pathnameSubRoutes.length; i >= 1; i--) {
    const possibleRoute = `/${pathnameSubRoutes.slice(0, i).join("/")}`;
    const possibleRouteIsValid = (Object.keys(InternalRoutes) as Array<
      keyof typeof InternalRoutes
    >).some(internalRoute => InternalRoutes[internalRoute] === possibleRoute);
    if (possibleRouteIsValid) {
      return possibleRoute;
    }
  }
  return null;
};

const findNearestValidRoute = (pathname: string) => {
  const isOnValidRoute = (Object.keys(InternalRoutes) as Array<
    keyof typeof InternalRoutes
  >).some(internalRoute => InternalRoutes[internalRoute] === pathname);
  if (isOnValidRoute) {
    return pathname;
  }
  return getHighestOrderNonModularRoute(pathname) || InternalRoutes.dashboard;
};

export default findNearestValidRoute;
